import { createElement, useState } from 'react';
import cx from 'classnames';
import { Icon, Card } from '@alifd/next';
import OpinionForm from '@/components/form/opinion-form';
import WorkFlowOpinionForm from '@/components/workflow/workflow-opinion-form';
const Slider = (props) => {
    const { workflowMode } = props;
    const [collapsed, setCollapsed] = useState(false);
    const renderOpinionForm = () => {
        switch (workflowMode) {
            case 'start':
                return createElement(OpinionForm, { ...props });
            case 'workflow':
                return createElement(WorkFlowOpinionForm, { ...props });
            default:
                return null;
        }
    };
    return (createElement("div", { className: cx({
            slider: true,
            collapsed,
        }) },
        createElement("span", { className: "collapse", onClick: () => setCollapsed(!collapsed) }, collapsed ? createElement(Icon, { type: "arrow-left" }) : createElement(Icon, { type: "arrow-right" })),
        createElement(Card, { free: true, hasBorder: false },
            createElement(Card.Header, { title: "\u5C97\u4F4D\u610F\u89C1" }),
            createElement(Card.Content, null, renderOpinionForm()))));
};
export default Slider;
